// will replace mma-in-masn-v2-ad-placements-styles after ad preview refreshed GA
export const getMmaInMsanV2PlacementBaseStyles = () => ({
  placementCard: {
    // border: '1px solid #c8c8c8',
    // boxShadow: 'unset !important',
    // borderRadius: '0px !important',
  },
  placementImageContainer: undefined,
  placementTextContainer: undefined,
  placementInfoContainer: undefined,
  placementAdsLabel: undefined,
  placementGradient: undefined,
  placementLogoContainer: undefined,
  placementBusinessNameContainer: undefined,
  placementShortHeadline: undefined,
  businuessAndLogoContainer: undefined,
  placementLongHeadline: undefined,
  placementFinalUrl: undefined,
  placementDescription: undefined,
  placementCallToAction: undefined,
  placementCallToActionAsLink: undefined,
  placementBusinessNameWithAdsLabel: undefined,
  businuessAndAdChoiceContainer: undefined,
  adsLabelClassName: undefined,
  headChoiceIconClassName: undefined,
  adsLabelContainerClassName: undefined,
});

export const getMmaInMsanV2RefreshedMSANRiver191x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '300px !important',
      height: 304,
      padding: '0px !important',
      border: '1px solid rgba(0, 0, 0, 0.05)',
    },

    placementImageContainer: {
      width: 300,
      height: 157,
      ...baseStyles.placementImageContainer,
    },

    placementTextContainer: {
      width: 300,
      height: 147,
    },

    placementInfoContainer: {
      height: 107,
      padding: '12px 16px 0',
      boxSizing: 'border-box',
    },

    businuessAndLogoContainer: {
      display: 'flex',
      marginBottom: 4,
    },

    placementLogoContainer: {
      height: 16,
      width: 16,
      marginRight: 8,
      '& .cropped-image-view': {
        borderRadius: '2px !important',
        '& img': {
          verticalAlign: 'top',
        },
      },
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'rgba(36, 36, 36,1)',
    },

    placementShortHeadline: {
      color: 'rgba(36, 36, 36,1)',
      fontFamily: 'Segoe UI',
      fontWeight: 600,
      fontSize: 20,
      lineHeight: '26px',
      marginBottom: 4,
      height: 52,
    },

    placementDescription: {
      color: 'rgba(36, 36, 36,1)',
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '20px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },

    businuessAndAdChoiceContainer: {
      height: 40,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
    },

    headChoiceIconClassName: {
      marginRight: 8,
    },

    adsLabelContainerClassName: {
      flexGrow: 1,
      height: 16,
    },

    adsLabelClassName: {
      display: 'inline-block',
      verticalAlign: 'top',
    },

    placementCallToAction: {
      border: '1px solid rgba(209, 209, 209, 1)',
      padding: '3px 8px',
      borderRadius: '4px',
      color: 'rgba(36, 36, 36, 1)',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'transparent',
    },

    placementCallToActionAsLink: {
      border: 'none',
      color: 'rgba(35, 92, 207, 1)',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
    },
  };
};

export const getMmaInMsanV2RefreshedMSNRestoday124x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '306px !important',
      height: 100,
      borderRadius: '6px !important',
      boxShadow: '0px 0px 2.9px 0px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13) !important',
      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row-reverse !important',
      },
    },

    placementImageContainer: {
      boxSizing: 'border-box',
      width: 112,
      height: '100%',
      padding: '8px 8px 8px 0',
      ...baseStyles.placementImageContainer,
      '& .cropped-image-view': {
        borderRadius: '4px !important',
      },
    },

    placementTextContainer: {
      flexGrow: 1,
      height: '100%',
    },

    businuessAndLogoContainer: {
      marginBottom: 4,
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'rgba(36, 36, 36,1)',
    },

    placementInfoContainer: {
      height: 68,
      padding: '8px 8px 0',
      boxSizing: 'border-box',
    },

    placementShortHeadline: {
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      color: 'rgba(36, 36, 36,1)',
    },

    businuessAndAdChoiceContainer: {
      height: 32,
      boxSizing: 'border-box',
      padding: '0px 8px',
      display: 'flex',
      alignItems: 'center',
    },

    adsLabelContainerClassName: {
      flexGrow: 1,
      height: 16,
    },

    adsLabelClassName: {
      display: 'inline-block',
      verticalAlign: 'top',
    },
  };
};

export const getMmaInMsanV2RefreshedMSNCarousel169x100Styles = (theme) => {
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '628px !important',
      height: 372,
      borderRadius: '6px !important',
      boxShadow: 'none !important',
    },

    placementImageContainer: {
      width: '100%',
      height: '100%',
      ...baseStyles.placementImageContainer,
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '194px',
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 100%)',
    },

    placementInfoContainer: {
      paddingTop: '80px',
      height: '150px',
      boxSizing: 'border-box',
    },

    placementLongHeadline: {
      padding: '0px 16px',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '28px',
      lineHeight: '35px',
      color: 'rgba(255, 255, 255, 1)',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 2, /* Limit to 2 lines */
      overflow: 'hidden',
    },

    businuessAndAdChoiceContainer: {
      height: 44,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
    },

    adsLabelContainerClassName: {
      marginRight: 8,
      height: 16,
    },

    adsLabelClassName: {
      borderColor: 'rgba(255, 255, 255, 0.3) !important',
      color: 'white !important',
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      flexGrow: 1,
      color: 'white',
    },
  };
};

export const getMmaInMsanV2RefreshedMicrosoftEdgeCarousel201x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      borderRadius: '8px !important',
      width: '612px !important',
      height: 304,
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '280px',
    },

    placementGradient: {
      display: 'block',
      width: '100%',
      height: '178px !important',
      background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 50.03%, rgba(30, 30, 30, 0.34) 88.85%, rgba(0, 0, 0, 0.44) 100%)',
    },

    placementInfoContainer: {
      padding: '12px 16px 0px',
      minHeight: '62px',
      boxSizing: 'border-box',
      background: 'linear-gradient(360deg, rgba(0, 0, 0, 0.54) 5.47%, rgba(0, 0, 0, 0.54) 55.63%, rgba(0, 0, 0, 0.49) 78.44%, rgba(0, 0, 0, 0.475) 89.43%, rgba(0, 0, 0, 0.44) 100%)',
    },

    businuessAndLogoContainer: {
      display: 'flex',
      marginBottom: 8,
    },

    placementLogoContainer: {
      height: 16,
      width: 16,
      marginRight: 8,
      '& .cropped-image-view': {
        borderRadius: '2px !important',
        '& img': {
          verticalAlign: 'top',
        },
      },
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'white',
    },

    placementShortHeadline: {
      color: 'white',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '20px',
      lineHeight: '26px',
    },

    businuessAndAdChoiceContainer: {
      height: 40,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
      background: 'var(--backplate-text-backplate-on-image-text-backplate-54451, rgba(0, 0, 0, 0.54))',
    },

    headChoiceIconClassName: {
      marginRight: 8,
    },

    adsLabelContainerClassName: {
      flexGrow: 1,
      height: 16,
    },

    adsLabelClassName: {
      display: 'inline-block',
      verticalAlign: 'top',
      borderColor: 'rgba(255, 255, 255, 0.3) !important',
      color: 'white !important',
    },

    placementCallToAction: {
      border: '1px solid',
      borderImageSource: 'linear-gradient(180deg, rgba(0, 0, 0, 0.0578) 90.58%, rgba(0, 0, 0, 0.1622) 100%)',
      padding: '3px 8px',
      borderRadius: '4px',
      color: 'rgba(255, 255, 255, 1)',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },

    placementCallToActionAsLink: {
      border: 'none',
      color: 'white',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'transparent',
    },
  };
};

export const getMmaInMsanV2RefreshedMSNPartnerStripe153x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);
  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '306px !important',
      height: 300,
      borderRadius: '4px  !important',
      boxShadow: '0px 0px 2.9px 0px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13) !important',
    },

    placementImageContainer: {
      height: 200,
      ...baseStyles.placementImageContainer,
    },

    placementInfoContainer: {
      padding: '8px 8px 0px',
      marginBottom: 24,
      height: 52,
      boxSizing: 'border-box',
    },

    placementLongHeadline: {
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '22px',
      color: 'rgba(36, 36, 36, 1)',
    },

    businuessAndAdChoiceContainer: {
      padding: '0px 8px',
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      color: 'rgba(36, 36, 36, 1)',
    },
  };
};

export const getMmaInMsanV2RefreshedMSANBanner2x1Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '396px !important',
      height: 100,
      borderRadius: '6px !important',
      boxShadow: '0px 0px 2.9px 0px rgba(0, 0, 0, 0.11), 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.13) !important',
      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row !important',
      },
    },

    placementImageContainer: {
      width: 200,
      height: 100,
      ...baseStyles.placementImageContainer,
    },

    placementTextContainer: {
      color: '#333',
      fontSize: 10,
      lineHeight: '16px',
      height: 100,
    },

    placementInfoContainer: {
      padding: '8px 8px 0',
      marginBottom: 20,
      height: 48,
      boxSizing: 'border-box',
    },

    placementShortHeadline: {
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      color: 'rgba(36, 36, 36,1)',
    },

    businuessAndAdChoiceContainer: {
      height: 32,
      boxSizing: 'border-box',
      padding: '0px 8px',
      display: 'flex',
      alignItems: 'center',
    },

    adsLabelContainerClassName: {
      marginRight: 6,
      height: 16,
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      color: 'rgba(36, 36, 36,1)',
    },
  };
};

export const getMmaInMsanV2RefreshedMicrosoftEdgeMobile1x1Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);

  return {

    placementCard: {
      ...baseStyles.placementCard,
      width: '398px !important',
      height: 145,
      padding: '16px',
      background: '#fff',
      borderRadius: '4px !important',
      border: '0.5px solid var(--Neutral-Stroke-3-Rest, rgba(240, 240, 240, 1))',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.04) !important',
      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row-reverse !important',
      },
    },

    placementImageContainer: {
      width: 114,
      height: 114,
      marginLeft: 16,
      ...baseStyles.placementImageContainer,
    },

    businuessAndLogoContainer: {
      display: 'flex',
      marginBottom: 4,
    },

    placementLogoContainer: {
      height: 16,
      width: 16,
      marginRight: 4,
      '& .cropped-image-view': {
        borderRadius: '2px !important',
        '& img': {
          verticalAlign: 'top',
        },
      },
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'rgba(36, 36, 36,1)',
    },

    placementTextContainer: {
      flexGrow: 1,
    },

    placementInfoContainer: {
      marginBottom: 18,
      height: 80,
    },

    placementShortHeadline: {
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      color: 'rgba(36, 36, 36,1)',
    },

    businuessAndAdChoiceContainer: {
      height: 16,
      boxSizing: 'border-box',
      padding: '0px',
      display: 'flex',
      alignItems: 'center',
    },

    adsLabelContainerClassName: {
      flexGrow: 1,
      height: 16,
    },

    adsLabelClassName: {
      display: 'inline-block',
      verticalAlign: 'top',
    },
  };
};

export const getMmaInMsanV2RefreshedMSANRectangle191x100Styles = (theme) => {
  // base styles
  const baseStyles = getMmaInMsanV2PlacementBaseStyles(theme);
  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '300px !important',
      height: 250,
      borderRadius: '6px !important',
    },

    placementImageContainer: {
      height: 157,
      ...baseStyles.placementImageContainer,
    },

    placementTextContainer: {
      padding: '8px 16px',
    },

    placementInfoContainer: {
      width: 224,
      paddingTop: '6px',
      height: 77,
      boxSizing: 'border-box',
    },

    businuessAndLogoContainer: {
      display: 'flex',
      marginBottom: 4,
    },

    placementLogoContainer: {
      width: 16,
      marginRight: 4,
      '& .cropped-image-view': {
        borderRadius: '2px !important',
        '& img': {
          verticalAlign: 'top',
        },
      },
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'rgba(97, 97, 97, 1)',
    },

    placementShortHeadline: {
      color: 'rgba(26, 26, 26, 1)',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '18px',
      lineHeight: '19px',
    },

    smallSizeHeadline: {
      fontSize: '14px',
    },

    customizedArea: {
      position: 'absolute',
      right: '16px',
      bottom: '28.5px',
    },

    placementDescription: {
      marginTop: 4,
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontZize: '14px',
      lineHeight: '20px',
      color: 'rgba(26, 26, 26, 1)',
    },

    businuessAndAdChoiceContainer: {
      position: 'absolute',
      right: 0,
      top: 0,
      width: '16px',
      height: '16px',
      borderBottomLeftRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
    },
  };
};
